import type { FC } from 'react';
import { cn } from 'src/utils/cn';

export const OperatorLogo: FC<{
  src: string;
  name: string;
  large?: boolean;
  testId?: string;
}> = ({ src, name, large, testId }) => {
  return (
    <img
      src={
        // stories use absolute urls, but real api uses relative ones
        src.startsWith('https://') ? src : PRISMA_CONFIG.monolithUrl + src
      }
      alt={`logo of ${name}`}
      className={cn(
        `mx-auto my-0 block h-[6rem] w-[13rem] object-contain`,
        large && `h-[8.8rem] w-[19rem]`
      )}
      // large={large}
      data-testid={testId}
    />
  );
};
